import type { LoadMode } from "./types.js";

export interface HistoryResultValue {
  weightValue: number | null;
  reps: number | null;
  countValue: number | null;
  durationSeconds?: number | null;
}

export interface LastPerformanceValue {
  weightValue: number | null;
  reps: number[];
  countValue: number | null;
  durations?: number[];
}

export function formatLastPerformance(
  mode: LoadMode,
  value: LastPerformanceValue,
) {
  if (value.durations?.length) return `${value.weightValue != null ? `${value.weightValue} kg${mode === 'kg_each' ? ' each' : ''} · ` : ''}${value.durations.join(' / ')} seconds`;
  if (mode === "count") return `${value.countValue ?? 0} count`;
  const reps = value.reps.length ? value.reps.join(" / ") : "—";
  if (mode === "bodyweight")
    return `${value.weightValue && value.weightValue > 0 ? `Bodyweight + ${value.weightValue} kg` : "Bodyweight"} · ${reps}`;
  return `${value.weightValue ?? "—"} kg${mode === 'kg_each' ? ' each' : ''} · ${reps}`;
}

export function formatExerciseResult(mode: LoadMode, row: HistoryResultValue) {
  if (row.durationSeconds != null) return `${row.weightValue != null && row.weightValue > 0 ? `${row.weightValue} kg${mode === 'kg_each' ? ' each' : ''} · ` : ''}${row.durationSeconds} seconds`;
  if (mode === "count") return `${row.countValue ?? 0} count`;
  if (mode === "bodyweight")
    return `${row.weightValue && row.weightValue > 0 ? `Bodyweight + ${row.weightValue} kg` : "Bodyweight"}${row.reps !== null ? ` · ${row.reps} reps` : ""}`;
  return `${row.weightValue !== null ? `${row.weightValue} kg${mode === 'kg_each' ? ' each' : ''} · ` : ""}${row.reps ?? 0} reps`;
}

export function historyMetricValue(
  metric: "weight" | "count" | "reps" | "seconds",
  row: HistoryResultValue,
) {
  return metric === 'seconds' ? (row.durationSeconds ?? 0) : metric === "count"
    ? (row.countValue ?? 0)
    : metric === "reps"
      ? (row.reps ?? 0)
      : (row.weightValue ?? 0);
}
